// GENERATED by scripts/write-env-secrets.js from AWS Secrets Manager. Do not edit or commit.
import { EnvSecrets } from './env-secrets.model';

export const secrets: EnvSecrets = {
  myhotelApiKey: "Upy1BTFzD63LFLzlkeCy72gFJokPrUGC4ZLUtbIq",
  facebookAppSecret: "a296d8c7cb730252e6f96e4f620d03ca",
  secretKeyCrypto: "1234567890abcdef",
};
